import * as React from 'react';
import { connect } from 'react-redux';
import * as moment from 'moment';

import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';

import { DateRangePicker, isInclusivelyBeforeDay } from 'react-dates';
import * as DatepickerActions from '../../actions/datepickers';
import * as DatepickerCreators from '../../creators/onCalendarRefreshButtonClick';

import State from '../../interfaces/states/State';

import './style.scss';

interface DispatchProps {
  fetchDatepickersStart: (startDate: moment.Moment) => void;
  fetchDatepickersEnd: (endDate: moment.Moment) => void;
  onCalendarRefreshButtonClick: () => void;
}

interface OwnProps {
  dateStart: moment.Moment;
  dateEnd: moment.Moment;
  focusedInput: null;
  activeTab: number;
}

interface Props extends DispatchProps, OwnProps {}

function DateRanger (props: Props) {

  const [focusedInput, setFocusedInput] = React.useState(null);

  const onCalendarButtonClick = React.useCallback(() => {
    props.onCalendarRefreshButtonClick();
    setFocusedInput(null);
  }, [props.onCalendarRefreshButtonClick]);

  return(
    <DateRangePicker
      daySize={37}
      renderCalendarInfo={() => (
        <button
          onClick={onCalendarButtonClick}
          className='calendar-button'>{'Apply'}</button>)}
      hideKeyboardShortcutsPanel
      customArrowIcon={null}
      firstDayOfWeek={1}
      startDateId='startDate'
      endDateId='endDate'
      startDate={props.dateStart}
      endDate={props.dateEnd}
      onDatesChange={React.useCallback(({ startDate, endDate }) => {
        props.fetchDatepickersStart(startDate);
        if (endDate) {
          props.fetchDatepickersEnd(endDate);
        }
      }, [props.fetchDatepickersStart, props.fetchDatepickersEnd])}
      displayFormat={() => 'DD/MM/YYYY'}
      anchorDirection='right'
      numberOfMonths={2}
      onClose={onCalendarButtonClick}
      // withPortal
      appendToBody
      keepOpenOnDateSelect
      navPrev={<span className='nav-prev-arrow'>{'‹'}</span>}
      navNext={<span className='nav-next-arrow'>{'›'}</span>}
      focusedInput={focusedInput}
      isOutsideRange={day => !isInclusivelyBeforeDay(day, moment())}
      onFocusChange={React.useCallback((focusedInput) => {
        setFocusedInput(focusedInput);
      }, [])}
    />
  );
  
}

const mapStateToProps = (state: State) => {
  return {
    dateStart: state.datepickers.dateStart,
    dateEnd: state.datepickers.dateEnd,
    focusedInput: state.datepickers.focusedInput,
    activeTab: state.findUser.activeTab,
  };
};

const mergeProps = (stateProps, dispatchProps: DispatchProps, props: OwnProps): Props => {
  return {
    ...stateProps,
    fetchDatepickersStart: dispatchProps.fetchDatepickersStart,
    fetchDatepickersEnd: dispatchProps.fetchDatepickersEnd,
    onCalendarRefreshButtonClick: dispatchProps.onCalendarRefreshButtonClick,
    ...props,
  };
};

export default connect(
  mapStateToProps, {
    fetchDatepickersStart: DatepickerActions.fetchDatepickersStartAction,
    fetchDatepickersEnd: DatepickerActions.fetchDatepickersEndAction,
    onCalendarRefreshButtonClick: DatepickerCreators.onCalendarRefreshButtonClick,
  }, mergeProps
)(React.memo(DateRanger));
